import React, {FC} from "react";
import {Calendar} from "@material-ui/pickers";
import {Button, Card, Typography} from "@material-ui/core";
import {isBefore, isToday} from "date-fns";
import {useHistory} from "react-router-dom";
import {AuthContext} from "../../../../auth/components/AuthProvider";
import {useWorkerCalendarDays} from "../../../orders/redux/orders.hook";
import {CreateAvailabilityDialogForm} from "../../../availibilities/form/CreateAvailabilityDialogForm";
import {CalendarLegend} from "./CalendarLegend";
import {CalendarDay} from "./CalendarDay";

export const WorkerCalendarScreen: FC = () => {
    const {userId} = React.useContext(AuthContext);
    const history = useHistory();
    const today = new Date();
    const [selectedDate] = React.useState(today);

    const [selectedMonth, setSelectedMonth] = React.useState<Date>(new Date());

    const navigateToCreateAvailability = () => {
        // history.replace(`${url}?mode=create&workerId=${userId}#availability`)
        const newSearchParams = new URLSearchParams(history.location.search);
        newSearchParams.set('mode', 'create');
        newSearchParams.set('workerId', userId || "");
        history.replace({
            pathname: history.location.pathname,
            search: `${newSearchParams.toString()}`,
            hash: 'availability'
        })
    };

    const {
        workerDays
    } = useWorkerCalendarDays(userId ?? "", selectedMonth);

    return (
        <div style={{paddingTop: 16}}>
            <CreateAvailabilityDialogForm hideWorkerSelect/>
            <Typography color="primary" variant="h5" style={{marginBottom: 16}}>
                Meine Verfügbarkeiten
            </Typography>
            <Card>
                <Calendar
                    date={selectedDate}
                    onMonthChange={month => {
                        if (month) {
                            setSelectedMonth(month);
                        }
                    }}
                    onChange={() => {
                    }}
                    renderDay={(day, selectedDate, dayInCurrentMonth) => (
                        day
                            ? <CalendarDay
                                workerId={userId ?? ""}
                                workerDay={workerDays[day.getDate() - 1]}
                                date={day}
                                disabled={((!dayInCurrentMonth || isBefore(day, new Date())) && !isToday(day)) }
                                today={Boolean(day && isToday(day.getTime()))}
                            />
                            : <React.Fragment/>
                    )}
                />
            </Card>
            <CalendarLegend/>
            <Button
                variant="contained"
                color="primary"
                style={{marginTop: 16}}
                onClick={navigateToCreateAvailability}
            >
                Verfügbarkeit Anlegen
            </Button>
        </div>
    )
}
